import React from 'react'
import { Skeleton } from '@mui/material'
import './tags.scss'

interface ComboboxTagProps {
    option: any
    tagProps?: any
    readOnly?: boolean
}

export const ComboboxTag = ({ option, tagProps, readOnly }: ComboboxTagProps) => (
    <span title={option.label} onClick={readOnly ? undefined : tagProps?.onDelete} className="combobox-tag">
        {option.label}
        {!readOnly && (
            <div className="combobox-tag-delete-container">
                <div className="combobox-tag-delete">&times;</div>
            </div>
        )}
    </span>
)

interface TagsProps {
    value: any[]
    loading?: boolean
    getTagProps?: (props: any) => any
    limitTags?: number
    readOnly?: boolean
}

export const Tags = ({ value, loading, getTagProps, limitTags, readOnly }: TagsProps) => {
    const excessTags = limitTags ? value.length - limitTags : 0
    if (loading) {
        return (
            <>
                <Skeleton variant="text" width={120} />
                <Skeleton variant="text" width={80} />
            </>
        )
    } else {
        return (
            <>
                {value.slice(0, limitTags).map((option, index) => {
                    if (!option) return null
                    const tagProps = getTagProps?.({ index })
                    return <ComboboxTag key={index} option={option} tagProps={tagProps} readOnly={readOnly} />
                })}
                {excessTags > 0 && <span className="combobox-excess-tags">+{excessTags} {readOnly ? 'more' : ''}</span>}
            </>
        )
    }
}
